/* eslint-disable max-lines */
const STATIC_PATH = '/static/img';
const VIDEOS_PATH = '/static/videos';

const LOGOS = {
    PARETO: {
        SRC: `${STATIC_PATH}/pareto-logo.png`,
        ALT: 'Pareto Logo',
    },
    PARETO_CLASSIC: {
        SRC: `${STATIC_PATH}/svg/pareto_logo_classica.svg`,
        ALT: 'Pareto Logo',
    },
    PARETO_WHITE: {
        SRC: `${STATIC_PATH}/svg/pareto_logo_branco_48.svg`,
        ALT: 'Pareto Logo',
    },
    PARETO_BLUE: {
        SRC: `${STATIC_PATH}/pareto-logo-blue.png`,
        ALT: 'Pareto Logo',
    },
    PARETO_WHITE_WITH_NAME: {
        SRC: `${STATIC_PATH}/svg/logo_com_nome_pareto_branco.svg`,
        ALT: 'Pareto Logo',
    },
    PARETO_TOAST: {
        ALT: 'Pareto Logo',
        SRC: `${STATIC_PATH}/pareto-logo-v2.png`,
    },
    PARETO_ADS: {
        SRC: `${STATIC_PATH}/svg/pareto_ads.svg`,
        ALT: 'Pareto Ads',
    },
    PARETO_SALES: {
        SRC: `${STATIC_PATH}/svg/pareto_sales.svg`,
        ALT: 'Pareto Sales',
    },
    PARETO_WORKFLOW: {
        SRC: `${STATIC_PATH}/svg/pareto_workflow.svg`,
        ALT: 'Pareto Workflow',
    },
    STRIPE: {
        SRC: `${STATIC_PATH}/powered-stripe.png`,
        ALT: 'Powerd by Stripe',
    },
    GOOGLE_ADS: {
        SRC: `${STATIC_PATH}/svg/google_dark.svg`,
        ALT: 'Google Ads',
        NAME: 'Google Ads',
        VALUE: 'google_ads',
    },
    GOOGLE_ANALYTICS: {
        SRC: `${STATIC_PATH}/svg/google_analytics_cinza.svg`,
        ALT: 'Google Analytics',
        NAME: 'Google Analytics',
        VALUE: 'google_analytics',
    },
    FACEBOOK_ADS: {
        SRC: `${STATIC_PATH}/svg/facebook_dark.svg`,
        ALT: 'Facebook Ads',
        NAME: 'Facebook Ads',
        VALUE: 'facebook_ads',
    },
    LINKEDIN_ADS: {
        SRC: `${STATIC_PATH}/svg/linkedin_cinza.svg`,
        ALT: 'Linkedin Ads',
        NAME: 'Linkedin Ads',
        VALUE: 'linkedin_ads',
    },
    LINKEDIN_ADS_2: {
        SRC: `${STATIC_PATH}/linkedinpng.png`,
        ALT: 'Linkedin Ads',
        NAME: 'Linkedin Ads',
        VALUE: 'linkedin_ads',
    },
    SEO: {
        SRC: `${STATIC_PATH}/svg/seo_cinza.svg`,
        ALT: 'SEO',
        NAME: 'SEO',
        VALUE: 'seo',
    },
    SEO_2: {
        SRC: `${STATIC_PATH}/seoicon.png`,
        ALT: 'SEO',
        NAME: 'SEO',
        VALUE: 'seo',
    },
    WAZE_ADS: {
        SRC: `${STATIC_PATH}/svg/waze_cinza.svg`,
        ALT: 'Waze Ads',
        NAME: 'Waze Ads',
        VALUE: 'waze_ads',
    },
    WAZE_ADS_2: {
        SRC: `${STATIC_PATH}/waze-a-d-s.png`,
        ALT: 'Waze Ads',
        NAME: 'Waze Ads',
        VALUE: 'waze_ads',
    },
    ALERT: {
        SRC: `${STATIC_PATH}/svg/alarme.svg`,
        ALT: 'Alert',
        NAME: 'Alert',
        VALUE: 'alert',
    },
    CLIENT: {
        SRC: `${STATIC_PATH}/svg/house_light.svg`,
        ALT: 'Client',
        NAME: 'Client',
        VALUE: 'client',
    },
    CLIENT_DARK: {
        SRC: `${STATIC_PATH}/svg/organization_icon.svg`,
        ALT: 'Client',
        NAME: 'Client',
        VALUE: 'client',
    },
    CREATE_CLIENT: {
        SRC: `${STATIC_PATH}/svg/home-24px.svg`,
        ALT: 'Create Client',
        NAME: 'Create Client',
        VALUE: 'create-client',
    },
    BING_ADS: {
        SRC: `${STATIC_PATH}/svg/bing_ads_cinza.svg`,
        ALT: 'Bing Ads',
        NAME: 'Bing Ads',
        VALUE: 'bing_ads',
    },
    CRITEO_ADS: {
        SRC: `${STATIC_PATH}/svg/critero_ads_cinza.svg`,
        ALT: 'Criteo Ads',
        NAME: 'Criteo Ads',
        VALUE: 'criteo_ads',
    },
    REGISTER: {
        SRC: `${STATIC_PATH}/register-logo.png`,
    },
    EMPTY: { SRC: '', ALT: '' },
};

const ACTIONS = {
    ARROW_DOWN: {
        SRC: `${STATIC_PATH}/svg/input-arrow-down.svg`,
    },
    CHECK: {
        SRC: `${STATIC_PATH}/svg/check.svg`,
    },
    SHARE: {
        SRC: `${STATIC_PATH}/svg/share.svg`,
        ALT: 'Share',
    },
    SHARE_LIGHT: {
        SRC: `${STATIC_PATH}/svg/share_light.svg`,
    },
    CLOSE: {
        SRC: `${STATIC_PATH}/svg/input-close.svg`,
        ALT: 'Close',
    },
    TRASH: {
        SRC: `${STATIC_PATH}/svg/lixeira_cinza-15.svg`,
        ALT: 'Delete',
    },
    TRASH_COMPANY: {
        SRC: `${STATIC_PATH}/svg/lixeira-vermelha-25.svg`,
        ALT: 'Delete',
    },
    DUPLICATE: {
        SRC: `${STATIC_PATH}/svg/duplicate.svg`,
        ALT: 'Duplicate',
    },
    DUPLICATE_SECONDARY: {
        SRC: `${STATIC_PATH}/svg/new_icons/duplicate.svg`,
        ALT: 'Duplicate',
    },
    ADDITION: {
        SRC: `${STATIC_PATH}/svg/plus-icon.svg`,
        ALT: 'Addition',
    },
};

const ICONS = {
    ARROW_DOWN: {
        SRC: `${STATIC_PATH}/svg/seta_baixo_azul-40.svg`,
        ALT: 'Arrow down',
    },
    CALENDAR: {
        SRC: `${STATIC_PATH}/calendaricon.png`,
        ALT: 'Calendar Icon',
    },
    CIRCLE_BLUE: {
        SRC: `${STATIC_PATH}/blue-circle.svg`,
    },
    CIRCLE_GREEN: {
        SRC: `${STATIC_PATH}/green-circle.svg`,
    },
    CIRCLE_PURPLE: {
        SRC: `${STATIC_PATH}/purple-circle.svg`,
    },
    CHECK_SYMBOL: {
        SRC: `${STATIC_PATH}/check-symbol.svg`,
    },
    CLOCK_GREEN: {
        SRC: `${STATIC_PATH}/icon-clock-green.png`,
        ALT: 'Green Clock',
    },
    CLOCK_RED: {
        SRC: `${STATIC_PATH}/icon-clock.png`,
        ALT: 'Red Clock',
    },
    CLOCK_GREY: {
        SRC: `${STATIC_PATH}/icon-clock-grey.svg`,
        ALT: 'Grey Clock',
    },
    CURRENCY_ICON: {
        SRC: `${STATIC_PATH}/svg/currency_icon.svg`,
        ALT: 'Currency Icon',
    },
    EDITABLE_FIELD_ICON: {
        SRC: `${STATIC_PATH}/editable_field_icon.png`,
    },
    FACEBOOK_BANNER: {
        SRC: `${STATIC_PATH}/facebook-banner.png`,
        ALT: 'Facebook banner',
    },
    FACEBOOK_CAROUSEL: {
        SRC: `${STATIC_PATH}/facebook-carousel.png`,
        ALT: 'Facebook carousel',
    },
    FACEBOOK_STORIES: {
        SRC: `${STATIC_PATH}/facebook-carousel.png`,
        ALT: 'Facebook stories',
    },
    FUNNEL: {
        SRC: `${STATIC_PATH}/svg/new_icons/funnel.svg`,
    },
    GEARS: {
        SRC: `${STATIC_PATH}/svg/gear.svg`,
        ALT: 'Settings',
    },
    HAMBURGUER_MENU: {
        SRC: `${STATIC_PATH}/svg/menu-hamburguer.svg`,
        ALT: gettext('Menu'),
    },
    LOADING: {
        SRC: `${STATIC_PATH}/loading.svg`,
    },
    MAGNIFIER: {
        SRC: `${STATIC_PATH}/svg/magnifier.svg`,
        ALT: 'Magnifier',
    },
    MASTER_CARD: {
        SRC: `${STATIC_PATH}/card.png`,
        ALT: 'Master Card Icon',
    },
    MEGAPHONE_LEFT: {
        SRC: `${STATIC_PATH}/megaphone_left.png`,
    },
    MONITOR: {
        SRC: `${STATIC_PATH}/svg/monitor.svg`,
    },
    PRIORITY_HIGH: {
        SRC: `${STATIC_PATH}/icon-high-p.png`,
        ALT: 'High Priority',
    },
    PRIORITY_MEDIUM: {
        SRC: `${STATIC_PATH}/icon-medium-p.png`,
        ALT: 'Medium Priority',
    },
    PRIORITY_LOW: {
        SRC: `${STATIC_PATH}/icon-low-p.png`,
        ALT: 'Low Priority',
    },
    STOP_WATCH: {
        SRC: `${STATIC_PATH}/svg/stop-watch-icon.svg`,
        ALT: 'Stop Watch',
    },
    VISA: {
        SRC: `${STATIC_PATH}/visa.png`,
        ALT: 'Visa Card Icon',
    },
    VISIBLE: {
        SRC: `${STATIC_PATH}/svg/visualização_cinza.svg`,
    },
    VISIBLE_TO_ALL: {
        SRC: `${STATIC_PATH}/svg/visible_to_all.svg`,
    },
    VISIBLE_TO_TEAM: {
        SRC: `${STATIC_PATH}/svg/visible_to_team.svg`,
    },
    VISIBLE_TO_ME: {
        SRC: `${STATIC_PATH}/svg/visible_to_me.svg`,
    },
    INVISIBLE: {
        SRC: `${STATIC_PATH}/icon.private.png`,
    },
    DEFAULT_USER_AVATAR: {
        SRC: '/static/img/default-user-avatar.png',
    },
    STORY_POINTS_ICON: {
        SRC: `${STATIC_PATH}/svg/story-points-icon.svg`,
    },
    STORY_POINTS_ICON_DARK: {
        SRC: `${STATIC_PATH}/svg/new_icons/storypoints.svg`,
    },
    GOAL: {
        SRC: `${STATIC_PATH}/svg/goal_chart.svg`,
        ALT: 'Goal',
    },
    HOT_SPOT_ICON: {
        SRC: `${STATIC_PATH}/svg/hot_spot.svg`,
        ALT: 'Hot Spot Icon',
    },
    CAMPAIGN_GROUP: {
        SRC: `${STATIC_PATH}/svg/campaign_group.svg`,
        ALT: 'Campaign Group Icon',
    },
    MEGAPHONE: {
        SRC: `${STATIC_PATH}/svg/megaphone.svg`,
        ALT: 'Megaphone Icon',
    },
    CAMPAIGN_REMOVED: {
        SRC: `${STATIC_PATH}/svg/campaign_removed.svg`,
        ALT: 'Status: Removed',
    },
    BELL: {
        SRC: `${STATIC_PATH}/svg/bell-light.svg`,
        ALT: 'Bell',
    },
};

const CARDS_PATH = `${STATIC_PATH}/svg/cards`;

const AGE_GROUPS = {
    AGE_GROUP_18_24: {
        ALT: 'Age Group 18-24',
        SRC: `${CARDS_PATH}/age-group-18-24.svg`,
    },
    AGE_GROUP_25_34: {
        ALT: 'Age Group 25-34',
        SRC: `${CARDS_PATH}/age-group-25-34.svg`,
    },
    AGE_GROUP_35_44: {
        ALT: 'Age Group 35-44',
        SRC: `${CARDS_PATH}/age-group-35-44.svg`,
    },
    AGE_GROUP_45_54: {
        ALT: 'Age Group 45-54',
        SRC: `${CARDS_PATH}/age-group-45-54.svg`,
    },
    AGE_GROUP_55_64: {
        ALT: 'Age Group 55-64',
        SRC: `${CARDS_PATH}/age-group-55-64.svg`,
    },
    AGE_GROUP_65_PLUS: {
        ALT: 'Age Group 65+',
        SRC: `${CARDS_PATH}/age-group-65+.svg`,
    },
    AGE_GROUP_UNDETERMINED: {
        ALT: 'Undetermined Age Group',
        SRC: `${CARDS_PATH}/age-group-undetermined.svg`,
    },
};
const deviceImageSrc = `${CARDS_PATH}/device.svg`;

const DEVICE_GROUPS = {
    DEVICE_MOBILE: {
        ALT: 'Mobile',
        SRC: deviceImageSrc,
    },
    DEVICE_TABLET: {
        ALT: 'Tablet',
        SRC: deviceImageSrc,
    },
    DEVICE_DESKTOP: {
        ALT: 'Desktop',
        SRC: deviceImageSrc,
    },
    DEVICE_UNDETERMINED: {
        ALT: 'Device Undetermined',
        SRC: deviceImageSrc,
    },
};

const genderDecreaseImageSrc = `${CARDS_PATH}/gender_decrease.svg`;
const genderIncreaseImageSrc = `${CARDS_PATH}/gender_increase.svg`;

const GENDER_GROUPS = {
    GENDER_GROUP_FEMALE: {
        DECREASE: {
            ALT: 'Female Gender Decrease',
            SRC: genderDecreaseImageSrc,
        },
        INCREASE: {
            ALT: 'Female Gender Decrease',
            SRC: genderIncreaseImageSrc,
        },
    },
    GENDER_GROUP_MALE: {
        DECREASE: {
            ALT: 'Male Gender Decrease',
            SRC: genderDecreaseImageSrc,
        },
        INCREASE: {
            ALT: 'Male Gender Increase',
            SRC: genderIncreaseImageSrc,
        },
    },
    GENDER_GROUP_UNDETERMINED: {
        DECREASE: {
            ALT: 'Undetermined Gender Decrease',
            SRC: genderDecreaseImageSrc,
        },
        INCREASE: {
            ALT: 'Undetermined Gender Increase',
            SRC: genderIncreaseImageSrc,
        },
    },
};

const parentalStatusDecreaseImageSrc = `${CARDS_PATH}/parental_decrease.svg`;
const parentalStatusIncreaseImageSrc = `${CARDS_PATH}/parental_increase.svg`;

const PARENTAL_STATUS_GROUP = {
    PARENTAL_STATUS_PARENT: {
        DECREASE: {
            ALT: 'Parents',
            SRC: parentalStatusDecreaseImageSrc,
        },
        INCREASE: {
            ALT: 'Parents',
            SRC: parentalStatusIncreaseImageSrc,
        },
    },
    PARENTAL_STATUS_NON_PARENT: {
        DECREASE: {
            ALT: 'Non-Parents',
            SRC: parentalStatusDecreaseImageSrc,
        },
        INCREASE: {
            ALT: 'Non-Parents',
            SRC: parentalStatusIncreaseImageSrc,
        },
    },
    PARENTAL_STATUS_UNDETERMINED: {
        DECREASE: {
            ALT: 'Undetermined Parental Status',
            SRC: parentalStatusDecreaseImageSrc,
        },
        INCREASE: {
            ALT: 'Undetermined Parental Status',
            SRC: parentalStatusIncreaseImageSrc,
        },
    },
};

const AD_SCHEDULE_GROUP = {
    AD_SCHEDULE_DAWN_ECONOMY: {
        ALT: 'Ad Schedule Early Morning',
        SRC: `${CARDS_PATH}/economy-dawn.svg`,
    },
    AD_SCHEDULE_DAWN_GROWTH: {
        ALT: 'Ad Schedule Early Morning',
        SRC: `${CARDS_PATH}/growth-dawn.svg`,
    },
    AD_SCHEDULE_MORNING_ECONOMY: {
        ALT: 'Ad Schedule Morning',
        SRC: `${CARDS_PATH}/economy-morning.svg`,
    },
    AD_SCHEDULE_MORNING_GROWTH: {
        ALT: 'Ad Schedule Morning',
        SRC: `${CARDS_PATH}/growth-morning.svg`,
    },
    AD_SCHEDULE_AFTERNOON_ECONOMY: {
        ALT: 'Ad Schedule Afternoon',
        SRC: `${CARDS_PATH}/economy-afternoon.svg`,
    },
    AD_SCHEDULE_AFTERNOON_GROWTH: {
        ALT: 'Ad Schedule Afternoon',
        SRC: `${CARDS_PATH}/growth-afternoon.svg`,
    },
    AD_SCHEDULE_NIGHT_ECONOMY: {
        ALT: 'Ad Schedule Night',
        SRC: `${CARDS_PATH}/economy-night.svg`,
    },
    AD_SCHEDULE_NIGHT_GROWTH: {
        ALT: 'Ad Schedule Night',
        SRC: `${CARDS_PATH}/growth-night.svg`,
    },
};

const GEO_TARGET_GROUP = {
    GEO_TARGET: {
        DECREASE: {
            ALT: 'Geo Target Decrease',
            SRC: `${CARDS_PATH}/geo-target-decrease.svg`,
        },
        INCREASE: {
            ALT: 'Geo Target Increase',
            SRC: `${CARDS_PATH}/geo-target-increase.svg`,
        },
    },
};

const CARD_HEADER_BACKGROUND = {
    ADS_IN_EXCESS: {
        ALT: 'Ads in Excess',
        SRC: `${CARDS_PATH}/ads-in-excess.svg`,
    },
    ADS_OVER_DAYS_BACKGROUND: {
        ALT: 'Ads Over 90 Days Old',
        SRC: `${CARDS_PATH}/ads-over-90-days.svg`,
    },
    DISPLAY_PERFORMANCE_BACKGROUND: {
        ALT: 'Display Peformance',
        SRC: `${STATIC_PATH}/svg/display_performance.svg`,
    },
    DISPLAY_PERFORMANCE_SHURB: {
        ALT: 'Display Peformance',
        SRC: `${STATIC_PATH}/svg/shrub_with_dog.svg`,
    },
    BRAND_DAMAGE_ALERT: {
        ALT: 'Brand Damage Alert',
        SRC: `${CARDS_PATH}/brand-damage-alert.svg`,
    },
    GOOGLE_BANNER_EXPERIMENTS: {
        ALT: 'Google Banner Experiments',
        SRC: `${CARDS_PATH}/google-banner-experiment.svg`,
    },
    DISPLAY_FRAUD_FINDER: {
        ALT: 'Display Fraud Finder',
        SRC: `${CARDS_PATH}/display-fraud-finder.svg`,
    },
    SHURB: {
        ALT: 'Shurb',
        SRC: `${CARDS_PATH}/shrub.svg`,
    },
    SMART_FUNNEL_INCREASE_ADJUST: {
        ALT: 'Smart Funnel Adjust Image 1',
        SRC: `${STATIC_PATH}/svg/card/smart-funnel-image-1.svg`,
    },
    SMART_FUNNEL_ADJUST_IMAGE_2: {
        ALT: 'Smart Funnel Adjust Image 2',
        SRC: `${STATIC_PATH}/svg/card/smart-funnel-image-2.svg`,
    },
    SMART_FUNNEL_ADJUST_IMAGE_3: {
        ALT: 'Smart Funnel Adjust Image 3',
        SRC: '/static/img/Caminho-1.1.png',
    },
    SMART_FUNNEL_DECREASE_ADJUST: {
        ALT: 'Smart Funnel Adjust Decrease Image 1',
        SRC: `${STATIC_PATH}/svg/card/smart-funnel-image-4.svg`,
    },
    MANUAL_CARD: {
        ALT: 'Manual Card',
        SRC: `${CARDS_PATH}/manual-card-background.svg`,
    },
    MANUAL_CARD_MOBILE: {
        ALT: 'Manual Card',
        SRC: `${CARDS_PATH}/manual-card-background-mobile.svg`,
    },
    KBA: {
        ALT: 'Keyword Bid Adjustment',
        SRC: `${CARDS_PATH}/mobile-apps-performance.svg`,
    },
    DELETE_COMPANY: {
        ALT: 'Delete Company',
        SRC1: `${STATIC_PATH}/svg/modal_background1.svg`,
        SRC2: `${STATIC_PATH}/svg/modal_background2.svg`,
        SRC: `${STATIC_PATH}/svg/delete_modal_background.svg`,
    },
    CREATE_COMPANY: {
        ALT: 'Create Company Background',
        SRC: `${STATIC_PATH}/create_modal_background.png`,
    },
    CONFIRMATION: {
        ALT: 'Confirmation Modal',
        SRC: `${STATIC_PATH}/svg/confirmation_modal_background.svg`,
    },
    NEW_CONFIRMATION: {
        ALT: 'Confirmation Modal',
        SRC: `${STATIC_PATH}/new_confirmation_modal_background.png`,
    },
    SEARCH_TERM: {
        ALT: 'Search Term Optimization',
        SRC: `${CARDS_PATH}/search-term.svg`,
    },
    SEARCH_TERM_BG: {
        ALT: 'Search Term Optimization',
        SRC: `${CARDS_PATH}/search-term-bg.svg`,
    },
    ...AGE_GROUPS,
    ...GENDER_GROUPS,
    ...PARENTAL_STATUS_GROUP,
    ...DEVICE_GROUPS,
    ...AD_SCHEDULE_GROUP,
    ...GEO_TARGET_GROUP,
};

const ADS_ACCOUNT = {
    FACEBOOK_ADS: {
        SRC: `${STATIC_PATH}/svg/facebook_dark.svg`,
    },
    GOOGLE_ADS: {
        SRC: `${STATIC_PATH}/svg/google_dark.svg`,
    },
    GOOGLE_ADS_LARGE: {
        SRC: `${STATIC_PATH}/svg/new_icons/googleads.svg`,
    },
    GOOGLE_ANALYTICS: {
        SRC: `${STATIC_PATH}/svg/google_analytics_cinza.svg`,
    },
};

// Image names should be interpolate with - to avoid adblock blocks
const SOCIAL_MEDIA_LOGOS = {
    AMAZON_ADS: `${STATIC_PATH}/a-mazon_logo.png`,
    APPLE_ADS: `${STATIC_PATH}/app-le-ads.png`,
    B2W_ADS: `${STATIC_PATH}/bw-2.png`,
    BING_ADS: `${STATIC_PATH}/bing-logo.png`,
    CRITEO: `${STATIC_PATH}/crit-eo.png`,
    FACEBOOK_ADS: `${STATIC_PATH}/svg/face-logo.svg`,
    FACEBOOK_CONNECT: `${STATIC_PATH}/facebookconnecticon.png`,
    GMAIL: `${STATIC_PATH}/gmail.png`,
    GOOGLE_ADS: `${STATIC_PATH}/svg/gad-s.svg`,
    GOOGLE_ADS_2: `${STATIC_PATH}/google-a-d-s-icon.png`,
    GOOGLE_ADS_3: `${STATIC_PATH}/googleadsicon.png`,
    GOOGLE_ANALYTICS: `${STATIC_PATH}/svg/ana-ly-tic.svg`,
    GOOGLE_MERCHANT: `${STATIC_PATH}/g-o-ogl-e-merch-ant@2.png`,
    INSTAGRAM: `${STATIC_PATH}/instagram.png`,
    LINKED_IN: `${STATIC_PATH}/linkd-in.png`,
    MERCADO_LIVRE_ADS: `${STATIC_PATH}/M-e-rcadoLivre.png`,
    VTEX: `${STATIC_PATH}/vt-ex.png`,
    SHOPIFY: `${STATIC_PATH}/shopify.png`,
    WAZE_ADS: `${STATIC_PATH}/wa-ze-a-d-s.png`,
    YOUTUBE: `${STATIC_PATH}/youtube.png`,
    PIPEDRIVE: `${STATIC_PATH}/svg/pipeicon.svg`,
    LOJA_INTEGRADA: `${STATIC_PATH}/svg/logo-lojaintegrada.svg`,
    WOOCOMMERCE: `${STATIC_PATH}/logo-woocommerce.png`,
};

const TASK_TYPES_GREY = {
    TASK: {
        SRC: `${STATIC_PATH}/svg/atividade_cinza.svg`,
        ALT: 'New Activity',
    },
    CALL: {
        SRC: `${STATIC_PATH}/svg/call_cinza.svg`,
        ALT: 'Call',
    },
    MEETING: {
        SRC: `${STATIC_PATH}/svg/meeting_cinza.svg`,
        ALT: 'Meeting',
    },
    EMAIL: {
        SRC: `${STATIC_PATH}/svg/email_cinza.svg`,
        ALT: 'Email',
    },
};

const TASK_TYPES_GREY_ENABLED = {
    TASK: {
        SRC: `${STATIC_PATH}/svg/new_icons/list-check.svg`,
        ALT: 'New Activity Enabled',
    },
    CALL: {
        SRC: `${STATIC_PATH}/svg/new_icons/phone-call.svg`,
        ALT: 'Call Enabled',
    },
    MEETING: {
        SRC: `${STATIC_PATH}/svg/new_icons/group.svg`,
        ALT: 'Meeting Enabled',
    },
    EMAIL: {
        SRC: `${STATIC_PATH}/svg/new_icons/envelope.svg`,
        ALT: 'Email Enabled',
    },
};

const VIDEOS = {
    CHECK_EMAIL: {
        SRC: `${VIDEOS_PATH}/checkemailvideo.mp4`,
    },
};

const HOTSPOT = {
    BACKGROUND: {
        SRC: `${STATIC_PATH}/svg/hotspot_background.svg`,
    },
    ILLUSTRATION: {
        SRC: `${STATIC_PATH}/svg/hotspot_illustration.svg`,
    },
};

const TAGSGROUP = {
    BACKGROUND: {
        SRC: `${STATIC_PATH}/svg/hotspot_background.svg`,
    },
    ILLUSTRATION: {
        SRC: `${STATIC_PATH}/svg/tags_group_illustration.svg`,
    },
};

const ILLUSTRATIONS = {
    GIRL_WITH_A_NOTEBOOK: {
        SRC: `${STATIC_PATH}/svg/girl_with_notebook.svg`,
        ALT: 'A girl with a notebook',
    },
};

const Images = {
    ACTIONS,
    ADS_ACCOUNT,
    CARD_HEADER_BACKGROUND,
    HOTSPOT,
    TAGSGROUP,
    ICONS,
    LOGOS,
    SOCIAL_MEDIA_LOGOS,
    TASK_TYPES_GREY,
    TASK_TYPES_GREY_ENABLED,
    VIDEOS,
    ILLUSTRATIONS,
};

export {
    STATIC_PATH,
    CARDS_PATH,
};

export default Images;
